const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3c3b01fe341ba34d1524f069265c901fabe499a4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"3c3b01fe341ba34d1524f069265c901fabe499a4"};
      